
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"26","rx":"2","fill":"#fff"}}),_c('circle',{attrs:{"cx":"15.5","cy":"12.5","r":"7.5","fill":"#BF3126"}}),_c('circle',{attrs:{"cx":"25.5","cy":"12.5","r":"7.5","fill":"#DFAC16"}})])
          )
        }
      }
    